document.addEventListener('DOMContentLoaded', function() {
  const cartGWPSection = document.querySelector('.gwp-section');
  if (!cartGWPSection) return;

  const observer = new MutationObserver(() => {
    
    const gwpTitle = cartGWPSection.querySelector('.gwp-title');
    if (gwpTitle && gwpTitle.textContent !== "Spend to Unlock Gifts") {
      gwpTitle.textContent = "Spend to Unlock Gifts";
    }

   
    const priceDivs = cartGWPSection.querySelectorAll('.gwp-product-price');
    priceDivs.forEach((div) => {
      if (div.textContent.includes(' USD')) {
        div.textContent = div.textContent.replace(' USD', '');
      }
    });

    
    const gwpButtons = cartGWPSection.querySelectorAll('.gwp-product-claim');
    gwpButtons.forEach((button) => {
      const desiredText = button.disabled ? 'Unlock' : 'Claim';
      if (button.textContent !== desiredText) {
        button.textContent = desiredText;
      }
    });
  });

  observer.observe(cartGWPSection, { childList: true, subtree: true });
});